import { render, staticRenderFns } from "./ReceiveStockWithInvoice.vue?vue&type=template&id=04620c95"
import script from "./ReceiveStockWithInvoice.vue?vue&type=script&lang=js"
export * from "./ReceiveStockWithInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports